export const getAddressButtonAriaLabel = (
  defaultShipping?: boolean,
  defaultBilling?: boolean,
  translations: Record<string, string> = {},
  type: 'removeButton' | 'editButton' = 'editButton'
): string => {
  const isRemove = type === 'removeButton';

  const labelMap = {
    shippingAndBilling: {
      edit: translations.editAddressAriaLabelShippingAndBilling,
      remove: translations.removeAddressAriaLabelShippingAndBilling,
    },
    shipping: {
      edit: translations.editAddressAriaLabelShipping,
      remove: translations.removeAddressAriaLabelShipping,
    },
    billing: {
      edit: translations.editAddressAriaLabelBilling,
      remove: translations.removeAddressAriaLabelBilling,
    },
    default: {
      edit: translations.editAddressAriaLabelDefault,
      remove: translations.removeAddressAriaLabelDefault,
    },
  };

  let key: keyof typeof labelMap = 'default';
  if (defaultShipping && defaultBilling) key = 'shippingAndBilling';
  else if (defaultShipping) key = 'shipping';
  else if (defaultBilling) key = 'billing';

  return isRemove ? labelMap[key].remove : labelMap[key].edit;
};
